var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDai(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2459.02 2459.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1,\n            .cls-3,\n            .cls-4,\n            .cls-6,\n            .cls-7,\n            .cls-8 {\n                fill: #fff;\n            }\n\n            .cls-1 {\n                opacity: 0.8;\n            }\n\n            .cls-2 {\n                fill: #febe44;\n            }\n\n            .cls-3 {\n                opacity: 0.6;\n            }\n\n            .cls-4 {\n                opacity: 0.7;\n            }\n\n            .cls-5 {\n                fill: #d9a547;\n                opacity: 0.42;\n                isolation: isolate;\n            }\n\n            .cls-6 {\n                opacity: 0.5;\n            }\n\n            .cls-7 {\n                opacity: 0.9;\n            }\n        "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DAI Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2171.05 1209.37 2170.95 1209.4 1229.51 2150.84 1229.51 2150.84 1229.51 2150.84 1229.51 2150.84 1229.51 1516.39 288 1209.38 1229.52 2150.9 2171.05 1209.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1229.51 267.23 1229.51 267.19 286.88 1209.02 288 1209.38 287.67 1209.06 1229.51 267.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2171.33 1209.02 2171.36 1209.06 2171.05 1209.37 2172.13 1209.02 1229.51 267.19 2171.34 1209.02 2171.33 1209.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2171.33 1209.02 2170.95 1209.4 2171.05 1209.37 2171.36 1209.06 2171.33 1209.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1229.51 942.62 1045.08 1147.54 614.75 1147.54 1229.51 461.08 1229.51 267.23 287.67 1209.06 288 1209.38 1229.51 1516.39 1229.51 942.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1229.51 2150.84 2170.95 1209.4 1229.51 1516.39 1229.51 2150.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1229.52 267.22 2171.33 1209.02 2171.34 1209.02 1229.51 267.19 1229.51 267.23 1229.52 267.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1229.52 267.22 2171.33 1209.02 2171.34 1209.02 1229.51 267.19 1229.51 267.23 1229.52 267.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1229.52 267.22 1229.51 267.23 1229.51 461.08 1864.75 1147.54 1434.43 1147.54 1229.51 942.62 1229.51 1516.39 2170.95 1209.4 2171.33 1209.02 1229.52 267.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1864.75 1147.54 1229.51 461.08 1229.51 942.62 1434.43 1147.54 1864.75 1147.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1229.51,0C550.47,0,0,550.47,0,1229.51S550.47,2459,1229.51,2459,2459,1908.55,2459,1229.51,1908.55,0,1229.51,0Zm0,2150.9L288,1209.38l-1.11-.36,942.62-941.83L2172.13,1209l-1.09.35Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "2171.33 1209.02 2170.95 1209.4 2171.05 1209.37 2171.36 1209.06 2171.33 1209.02"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDai);
export default __webpack_public_path__ + "static/media/dai.932518eb.svg";
export { ForwardRef as ReactComponent };